import { render } from "./ProjectSave.vue?vue&type=template&id=87f914fc"
import script from "./ProjectSave.vue?vue&type=script&lang=js"
export * from "./ProjectSave.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__